import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies';

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueSweetalert2 from 'vue-sweetalert2';
import VueEllipseProgress from 'vue-ellipse-progress';
import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCookies);

Vue.use(VueCompositionAPI)
Vue.use(VueEllipseProgress);


const options = {
  // You can set your default options here
};
Vue.use(Toast, options);
Vue.use(VueSweetalert2);
Vue.use(VueCookies);


Vue.use(Vuetify, {theme: {background: "#f0f0f0"}});
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify : new Vuetify(),
  render: h => h(App)
}).$mount('#app')
